<template>
    <GenericTable
        :Variant="Variant" 
        :Headers="headers"
        :Rows="Results"
        :EnableSelection="true"
        :SelectionType="selectionTypeEnum.Simple"
        :EnablePagination="true"
        :PerPage="itemPerPage"
        :ShowDeleteButton="false"
        :ShowModifyButton="false"
        :ShowSearchField="false"
        :ShowColumnsSelector="false"
        :ShowToggleSelectionAll="false"
        @ClickOnRowsEvent="OnRowSelected">
        <!-- COLONNE D'AFFICHAGE DES ENERGIES DU COMPTEUR -->
        <template #column(Expendables)="row">
            <ExpendableCell :Values="row.row.Expendables"/>
        </template>
    </GenericTable>
</template>
<script lang="ts">

    /**
     * Composant Vue js
     */
    import Component from 'vue-class-component';

    /**
     * Affichage de recherche
     */
    import { SearchDisplayer } from '../SearchDisplayer';

    /**
     * Composants tableau générique
     */
    import { HeaderIcon, HeaderString, IconType, IHeader } from '../../Generics/GenericTable/GenericTableHeader';
    import GenericTable, { CssClass } from '../../Generics/GenericTable.vue';
    import ExpendableCell from '@/components/MasterPage/Administration/SMAForm/CustomsCells/ExpendableCell.vue';

    @Component({
        components: {
            ExpendableCell,
            GenericTable
        }
    })
    export default class ShortMeterSearchDisplayer extends SearchDisplayer {
        
        /**
         * En-têtes du tableau de résultat des ShortMeter
         */
        private headers: IHeader[] = [
            new HeaderIcon('ObjectType', this.$t('ObjectType').toString(), {
                CssClasses: [new CssClass({CssClass: 'text-center'})],
                IconType: IconType.Path,
                ShowLabel: false,
                Sort: false,
            }),
            new HeaderString('RaepceNumber', this.$t('RAEPCENumber').toString(), {Sort: true}),
            new HeaderString('Name', this.$t('Name').toString(), {Sort: true}),
            new HeaderString('Expendables', this.$t('Expendables').toString(), {Sort: false})
        ];
    }
</script>
<style scoped>
</style>